import { overlayBackground } from '@/styles/common';
import { flexCenter } from '@/styles/layout';
import { THEME } from '@/styles/theme';
import styled from 'styled-components';

export const CheckPinCodeOverlay = styled.div`
  position: fixed;
  inset: 0;
  ${overlayBackground};
  z-index: ${THEME.modal.zIndex};
`;

export const CheckPinCodeWrapper = styled.div`
  ${flexCenter};
  height: 100%;
`;
